import { VendorType } from 'app/entity/models/entity';

export const ALL_VENDORS: VendorType[] = Object.values(VendorType);
export const ALWAYS_AVAILABLE_VENDORS: VendorType[] = [VendorType.HOOPLA];
export const GET_MATERIAL_VENDORS: VendorType[] = [VendorType.OAI_PMH];
export const ECONTENT_VENDORS_WITH_ISSUES = [VendorType.OVERDRIVE];
